export const API = {
  signup: "/owners",
  adminSignIn: "/oauth/token",
  propertiesSearch: "/properties-search",
  properties: "/properties",
  ownerPortalProperties: "/owner-portal/properties",
  ownerPortalAppeals: "/owner-portal/appeals",
  ownerPortalInvoices: "/owner-portal/invoices",
  getOwnersList: "/properties?documents_yn=1",
  sendReferralEmail: "/send-referral-email",
  ownersEmailList: "/owners/autocomplete/email",
  referrals: "/referrals",
  syncProperty: "/sync-property",
  accountLogs: "/account-logs",
  propertyOwner: "/property-owner",
  checkEmail: "/check-user",
  checkCode: "/verify-code",
  getColumnOrder: "/get-sequence",
  saveColumnOrder: "/save-sequence",
  getProtestedAccountsList: "/protested-accounts",
  uploadFile: "/upload-file",
  getHearingDatesList: "/hearing-dates",
  notes: "/notes/update-or-create",
  me: "/owner-portal/me",
  ownerPortal: "/owner-portal",
  leads: "/leads",
  documents: "/documents",
  documentsAoa: "/documents/aoa",
  documentsSa: "/documents/sa",
  docs: "/docs",
  sendAoA: "/send-aoa",
  ownerReferrals: "/owner-referrals",
  exportCSV: "/export-csv",
  agentExportCSV: "/agent-export-csv",
  syncProperties: "/sync-properties",
  ownerReferredBy: "/owner-referred-by",
  propertiesSearchAddress: "/properties-search-address",
  getPropertyInfo: "/get-property-info",
  multipleCreate: "/multiple-create",
  archives: "/archives",
  contactAgain: "/contact-again",
  evidences: "/evidences",
  evidenceStatus: "/get-comps-status",
  changeCompsStatus: "/change-comps-status",
  comps: "/comps",
  importAccounts: "/import-accounts",
  importArchiveProperties: "/import-archive-properties",
  getSaveComps: "/get-save-comps",
  leftBarValues: "/left-bar/values",
  saveComps: "/save-comps",
  equities: "/equities",
  sales: "/sales",
  massPrint: "/mass-print",
  print: "/print",
  printFullComp: "/print-full-comp",
  printComp: "/print-comp",
  archiveProperty: "/properties/archive",
  clientEvidence: "/client-evidences",
  changeEvidenceStatus: "/change-evidence-status",
  changeFileStatus: "/change-file-status",
  mergeEvidenceFiles: "/evidence-file-merge",
  changeFileType: "/change-file-type",
  changeFileName: "/change-file-name",
  adminUsers: "/admin/users",
  usersMe: "/users/me",
  addFile: "/add-file",
  getAllPermissions: "/get-all-permissions",
  admin: "/admin",
  aoaDocs: "/aoa-docs",
  saDocs: "/sa-docs",
  verifyAllAoa: "/sync-yes-properties",
  action: "/action",
  actions: "/actions",
  tracker: "/tracker",
  owners: "/owners",
  flags: "/flags",
  property: "/property",
  deleteProperty: "/delete-property",
  addReceiver: "/add-receiver",
  discounts: "/discounts",
  updateSender: "/update-sender",
  completeSignup: "/complete-signup",
  dashboard: "/v2properties",
  updateComment: "/update-comment",
  unarchiveProperty: "/unarchive",
  getAppliedFilters: "/get-filters",
  filters: "/filters",
  save: "/save",
  subject: "/subject",
  accountNumber: "/account-number",
  streetAddress: "/street-address",
  file: "/file",
  upcomingHearings: "/upcoming-hearings",
  complete: "/complete",
  getNotes: "/property-notes",
  notifications: "/notifications",
  read: "/read",
  updateEmail: "/update-email",
  referralsOwnerPortal: "/owner-portal/owner-referrals",
  referredByOwnerPortal: "/owner-portal/owner-referred-by",
  getOwnerReferralCode: "/owner-portal/owner-referral-code",
  authedOrNot: "/owner-portal/authed-or-not",
  updateAccountInfo: "/owner-portal/owner",
  getNotifications: "/admin/notification",
  readAllNotifications: "/admin/notification/read",
  archiveFile: "/archive-file",
  changeContactedStatus: "/change-contacted-status",
  smsEligibility: "/admin/sms-eligibility",
  smsEligibilityExport: "/admin/sms-eligibility-export",
};
